import React from 'react'
import { useSelector } from 'react-redux'
import { Icon } from '@shopify/polaris'
import { StoreIcon, LocationIcon, PersonIcon, GlobeAsiaIcon } from '@shopify/polaris-icons'
import { useTranslation } from 'react-i18next'

const UserInfoModal = ({ isOpen, onClose }) => {
    const user = useSelector((state: any) => state.user)
    const { t } = useTranslation()

    if (!isOpen) return null

    const renderSection = (title, icon, items, isAll = false) =>
        (items?.length > 0 || isAll) && (
            <div className="mb-3">
                <div className="is-flex is-align-items-center mb-1">
                    <span className="icon is-small mr-1">
                        <Icon source={icon} />
                    </span>
                    <h3 className="is-size-7 has-text-weight-semibold">{title}</h3>
                </div>
                <div className="tags are-small">
                    {isAll ? (
                        <span className="tag is-info is-light">All {title}</span>
                    ) : (
                        items.map((item, index) => (
                            <span key={index} className="tag is-info is-light">
                                {item}
                            </span>
                        ))
                    )}
                </div>
            </div>
        )

    const getStoreLabels = () => user.stores?.map((store) => store.label) || []
    const getDistributionZoneLabels = () =>
        !user.isAllDistributionZones ? user.distributionzones?.map((zone) => zone.label) || [] : []
    const getClientLabels = () => (!user.isAllClients ? user.clients?.map((client) => client.label) || [] : [])
    const getRegionLabels = () => user.regions?.map((region) => region.label) || []

    return (
        <div className={`modal ${isOpen ? 'is-active' : ''}`}>
            <div className="modal-background"></div>
            <div className="modal-card" style={{ maxWidth: '600px' }}>
                <header className="modal-card-head py-2">
                    <p className="modal-card-title is-size-6">Account Information</p>
                    <button className="delete" aria-label="close" onClick={onClose}></button>
                </header>

                <section className="modal-card-body p-3">
                    <div className="box p-4">
                        <div className="columns is-mobile is-vcentered m-0">
                            <div className="column is-narrow pr-4">
                                <figure className="image is-64x64">
                                    <img
                                        src="https://ui-avatars.com/api/?name=Sepehr"
                                        className="is-rounded"
                                        alt="User avatar"
                                    />
                                </figure>
                            </div>

                            <div className="column">
                                <div className="mb-2 has-text-left">
                                    <h3 className="title is-5">
                                        {user.firstName} {user.lastName}
                                    </h3>
                                    <p className="subtitle is-7 has-text-grey m-0 p-0">{user.email}</p>
                                    <p className="subtitle is-7 has-text-grey p-0 m-0">{user.phone || ''}</p>
                                </div>

                                <div className="field is-grouped is-grouped-multiline">
                                    <div className="control">
                                        <div className="tags are-small">
                                            {user.isDriver && <span className="tag is-success">Driver</span>}
                                            {user.isSBCustomer && <span className="tag is-primary">Staff</span>}
                                            {user.isVendor && <span className="tag is-dark">Client</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content">
                        {renderSection('Regions', GlobeAsiaIcon, getRegionLabels())}
                        {renderSection(
                            t('distributionZones').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
                            LocationIcon,
                            getDistributionZoneLabels(),
                            user.isAllDistributionZones
                        )}
                        {renderSection('Clients', PersonIcon, getClientLabels(), user.isAllClients)}
                        {renderSection('Assigned Stores', StoreIcon, getStoreLabels())}
                    </div>
                </section>
            </div>
        </div>
    )
}

export default React.memo(UserInfoModal)
